<template>
  <div class="contenedor-difusion">
    <!-- <Header2/> -->
    <section class="contenedor-c">
      <div class="contenedor-titulo">
        <h1>Nivel 1</h1>
        <div class="barra"></div>
      </div>
      <section class="contenedor-login">
        <div class="contenedor-difusion-imagen">
          <img src="@/assets/abhi.png" alt="Abhi Iyengar">
        </div>
        <div class="contenedor-seminario">

          <p>“<i>Cultiven en los alumnos la alegría del proceso de aprendizaje, en vez de llegar a un destino.”</i> <br> — Geeta y Prashant Iyengar</p>

          <p>A partir de la CERTIFICACIÓN NIVEL 1, los profesores y profesoras están habilitadas únicamente para impartir clases generales donde deben demostrar, observar y corregir.</p>
          <h2 class="titulo_beneficios">Clases generales</h2>

          <ul class="lista_precios_seminario">
            <li>⚬ Solo pueden dictar clases generales de 1 hora y 15 minutos, o 1 hora y 30 minutos de duración.</li>
            <li>⚬ Las clases deben ajustarse al <b>silabario correspondiente</b> a su nivel de certificación.</li>
            <li>⚬ No podrán dictar clases terapéuticas.</li>
            <li>⚬ No se permite mezclar otros métodos de enseñanza.</li>
            <li>⚬ Es fundamental respetar la evolución de cada estudiante, adaptándose a sus necesidades sin forzar el aprendizaje.</li>
          </ul>

          <h2 class="titulo_beneficios">Embarazo</h2>

          <ul class="lista_precios_seminario">
            <li>⚬ No podrán dictar clases específicas para embarazadas.</li>
            <li>⚬ Podrán continuar guiando a alumnas regulares que han quedado embarazadas, siempre que se trate de <b>embarazos sin complicaciones</b>.</li>
            <li>⚬ En caso de embarazos con complicaciones, la alumna debe ser derivada a una persona certificada en Nivel III o superior.</li>
            <li>⚬ Si en la región no hubiera nivel III o superior, podrán continuar enseñando <b>solo bajo consulta y supervisión</b> de una persona con dicha certificación.</li>
          </ul>

          <h2 class="titulo_beneficios">Abordaje Terapéutico</h2>

          <ul class="lista_precios_seminario">
            <li>⚬ Pueden atender <b>problemas comunes</b> dentro de sus clases (dolor de cuello, hombros, espalda baja o rodillas).</li>
            <li>⚬ No están habilitadas a ofrecer clases específicas con fines terapéuticos.</li>
            <li>⚬ Si un estudiante requiere atención terapéutica, debe ser derivado a una persona certificada en Nivel III o superior.</li>
            <li>⚬ Si en la región no hubiera nivel III o superior, podrán continuar enseñando <b>solo bajo consulta y supervisión</b> de un profesor con dicha certificación.</li>
          </ul>

          <h2 class="titulo_beneficios">Clases Especiales</h2>

          <p>Si bien el Manual de Certificación 2020 no contempla la posibilidad de que los profesores de Nivel I realicen clases especiales, talleres, workshops o retiros, en atención a las particularidades de nuestro país y con el espíritu de preservar las enseñanzas de B.K.S. Iyengar, así como de fomentar la formación continua en el método, se establece que:</p>

          <p><b>Nivel 1: <br>A partir de 2 años cumplidos de la certificación Nivel 1, podrán dictar clases especiales. <br>¿Qué se considera una clase especial?</b></p>

          <p>Se considera clase especial a toda sesión de enseñanza de la metodología y práctica del Yoga Iyengar® que cumpla con una o más de las siguientes condiciones:</p>

          <ul class="lista_precios_seminario">
            <li>⚬ Si supera los 90 minutos de duración.</li>
            <li>⚬ Si se dicta fuera del cronograma habitual de clases.</li>
            <li>⚬ Si está dirigido a personas más allá de los alumnos regulares de la sala.</li>
          </ul>

          <p><b><u>La clase especial</u></b> podrá tener una duración de 2 horas máximo.Podrá abordar un tema específico del método, siempre basado en asanas y pranayamas del silabario correspondiente al nivel I, como por ejemplo:</p>

          <ul class="lista_precios_seminario">
            <li>⚬ Uso de elementos en las posturas.</li>
            <li>⚬ Principios de alineación en posturas de pie.</li>
            <li>⚬ Práctica de flexiones hacia adelante.</li>
            <li>⚬ Práctica de extensiones hacia atrás.</li>
            <li>⚬ Práctica de posturas invertidas.</li>
            <li>⚬ Introducción al pranayama.</li>
            <li>⚬ NO se podrá nombrar una parte del cuerpo específica, como por ejemplo “Taller de caderas” , o “Taller de espalda baja”.</li>
            <li>⚬ Se podrá dictar solo 1 clase especial de 2 horas al mes.</li>
            <li>⚬ No se podrá dictar retiros, talleres ni workshops.</li>
          </ul>

          <h2 class="titulo_beneficios">Requisitos</h2>

          <ul class="lista_precios_seminario">
            <li>1. Haber dictado clases generales de Nivel I por un mínimo de dos (2) años desde la certificación.</li>
            <li>2. Participar regularmente en los encuentros organizados por la AAYI con profesores del RIMYI.</li>
            <li>3. Tomar clases regulares y mantener un vínculo cercano con un mentor/a o profesor/a de mayor nivel. Este acompañamiento no solo ofrece sostén y guía en cada paso, sino que también enriquece la formación continua y fortalece el sentido de comunidad.</li>
          </ul>

          <h2 class="titulo_beneficios">Pasos a seguir</h2>

          <ul class="lista_precios_seminario">
            <li>1. La persona interesada deberá presentar cada proyecto detallando el contenido, ajustado al programa de Nivel I y avalado por su mentor/a o profesor/a de mayor nivel.</li>

            <li>2. Obtener la conformidad de su mentor/a para cada actividad a realizar, quien firmará una carta de recomendación: <a
             href="https://drive.google.com/file/d/1y0fPVBJnXaAykCQPzd3yg3lJ64CJbex2/view"
             target="_blank"
             class="link_beneficios"
             >
              Link carta de recomendación
            </a></li>
            <li>3. Completar el siguiente formulario por cada actividad que se desee organizar: <a
             href="https://docs.google.com/forms/d/e/1FAIpQLSfhx8Xb-VdcifKnG2ui94OrbCZwQwpIaSnnX1mBrz9gYrAWEA/viewform"
             target="_blank"
             class="link_beneficios"
             >
              Link formulario de registro
            </a></li>
            <!-- <ul class="lista_precios_seminario">
              <li>⚬ Expresar el interés en difundir el método.</li>
              <li>⚬ Presentar un proyecto detallado con el contenido del taller, ajustado al programa de Nivel I.</li>
              <li>⚬ Obtener la conformidad del mentor para cada actividad a realizar, quien firmará una carta de recomendación: <a
             href="https://drive.google.com/file/d/1y0fPVBJnXaAykCQPzd3yg3lJ64CJbex2/view"
             target="_blank"
             class="link_beneficios"
             >
              Link carta de recomendación
            </a></li>
              <li>⚬ Completar el siguiente formulario por cada actividad que se desee organizar: <a
             href="https://docs.google.com/forms/d/e/1FAIpQLSfhx8Xb-VdcifKnG2ui94OrbCZwQwpIaSnnX1mBrz9gYrAWEA/viewform"
             target="_blank"
             class="link_beneficios"
             >
              Link formulario de registro
            </a></li>
            </ul> -->
          </ul>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import store from '../store'
export default {
  name: 'Nivel1Requisitos',
  components: {
  },
  data: function () {
    return {
      store,
      checked: false
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<style>

</style>
